<template>
  <b-card no-body>
    <b-table 
      :fields="[{label:'Omschrijving',key:'naam'}].concat(acties.map((a,index) => { return { label: a.naam, key: index.toString() } }))" 
      :items="onderdeel.acties" 
      small
    >
      <template #cell(naam)="data">
        {{ data.item.naam }}
      </template>
      <template #cell()="data">
        <b-button @click="importHerhaling(data.field.key, data.item)">
          {{ data.field.label }} {{ getImportItemBedrag(data.field.key) }}
        </b-button>
      </template>
    </b-table>
  </b-card>
</template>
<script>
import {serviceMixin} from '@/mixins/serviceMixin';

export default {
  name: "ChecklistItemTypeB",
  mixins: [ serviceMixin ],
  props: {
    onderdeel: {
      type: Object,
      required:true
    },
    item: {
      type:Object,
      required:true
    }
  },
  data() {
    return {
      jaar: null,
      prognose: null
    }
  },
  computed: {
    acties: function() {
          var vm = this;
          var a = [];
          if (this.prognose) {
            this.prognose.onderdelen.forEach(elem =>
              elem.onderdelen.forEach(function(o) {
                console.log(o);
                if (o.legacyId == "onderdeel_" + vm.onderdeel.import)
                  a = o.onderdelen;
              })
            );
          }
          return a;
        },
  },
  mounted() {
      this.getImportPrognose();
    },
  methods: {
    jaarChanged() {
      this.onderdeel.jaar = this.jaar - 10;
    },
    importHerhaling(index, item) {
      console.log(index, item);
      item.werkzaamheden = this.getImportItem(index) .omschrijving;
      if (!item.bedraglocked) item.bedrag = this.getImportItemBedrag(index)
      item.jaar = this.getImportItem(index).eersteJaar - item.cyclus;
    },
    getImportItem(index) {
      return this.acties[index];
    },
    getImportItemBedrag(index) {
      var item = this.getImportItem(index);
      return item.resultaat[item.eersteJaar - this.prognose.jaar];
    },
    getImportPrognose() {
      var vm = this;
      this.get("/unit/" + this.$route.params.id + "/prognose")
        .then(function(response) {
          vm.prognose = response.data.imports;
        })
        .catch(function(error) {
          console.log(error)
        });
    },
  }
};
</script>
